export function getKeyboardFocusableElements(element = document) {
	return [
		...element.querySelectorAll(
			'a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])'
		),
	].filter(el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));
}

export function isElement(element) {
	return element instanceof Element || element instanceof HTMLDocument;
}

export function isInViewport(elem) {
	const bounding = elem.getBoundingClientRect();
	return (
		bounding.top >= 0 &&
		bounding.left >= 0 &&
		bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}

export function iOS() {
	return (
		['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
		// iPad on iOS 13 detection
		(navigator.userAgent.includes('Mac') && 'ontouchend' in document)
	);
}

export function lerp(a, b, n) {
	return (1 - n) * a + n * b;
}

// Map number x from range [a, b] to [c, d]
export function map(x, a, b, c, d) {
	return ((x - a) * (d - c)) / (b - a) + c;
}